module.exports = __webpack_public_path__ + "static/P3-c76ce8dbb39676053f99eea4c95bb1cb.pdf";